'use client';

import { CategoriesSlider, HeroSlider } from '@/components/ui/sliders';
import { usePathname } from '@/i18n/navigation';
import useCategoryStore from '@/store/category.store';
import {
  event_view_brand,
  event_view_category,
  event_view_sub_category,
} from '@/utils/gtm';
import { useLocale } from 'next-intl';
import { useEffect } from 'react';
// import Image from '@/components/image';

function Header({ categoryId, isMobile }) {
  const pathname = usePathname();
  const locale = useLocale();
  const { getCurrentCategory } = useCategoryStore();
  const currentCategory = getCurrentCategory('innova_url', categoryId);

  const subCategories =
    currentCategory?.children_data?.filter(
      (c) => c.is_active && c.include_in_menu == '1' && c?.product_count > 0
    ) || [];

  useEffect(() => {
    if (pathname?.startsWith('/b/') && !!currentCategory) {
      event_view_brand({
        brand_category: currentCategory?.url_key,
        brand_name: currentCategory?.name,
      });
    } else if (!!currentCategory) {
      const isSubCategory = pathname.split('/')?.length > 3;
      if (isSubCategory) {
        event_view_sub_category({
          parent_category_id: currentCategory?.parent_id,
          sub_category_id: currentCategory?.id,
          sub_category_name: currentCategory?.name,
          parent_category_name: currentCategory?.parent_name,
        });
      } else {
        const is_offer = pathname.includes('/offer');
        event_view_category({
          parent_category_id: currentCategory?.id,
          parent_category_name: currentCategory?.name,
          is_offer,
        });
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [categoryId, currentCategory, pathname]);

  return (
    <>
      <div className='mb-3.5'>
        <h1 className='text-sm font-bold max-md:hidden sm:text-xl'>
          {currentCategory?.name}
        </h1>

        {/* Image Wrapper */}
        {/* {categoryBannerImage ? (
          <div className='relative my-3.75 w-full overflow-hidden rounded-lg md:my-5'>
            {!_hasHydrated ? (
              <div className='absolute top-0 left-0 h-53 w-full animate-pulse rounded-sm bg-gray-100 px-3' />
            ) : (
              <Image
                width={1600}
                src={categoryBannerImage}
                alt={currentCategory?.name}
                fill
                className='h-auto w-full'
              />
            )}
          </div>
        ) : null} */}

        {currentCategory?.category_sliders?.length > 0 && (
          <HeroSlider
            category_sliders={currentCategory?.category_sliders}
            featured_banners={
              currentCategory?.featured_banners.slice(0, 2) || []
            }
            isMobile={isMobile}
            fromPLP
          />
        )}
      </div>
      <div className='mb-4 sm:mb-5.5 lg:mb-[29px]'>
        {subCategories?.filter((info) => !!info?.['category_mobile_image1'])
          ?.length > 0 && (
          <CategoriesSlider
            isMobile={isMobile}
            fromPLP
            data={{
              value: subCategories?.filter(
                (info) => !!info?.['category_mobile_image1']
              ),
              'title-en': 'Featured Categories',
              'title-ar': 'الفئات المميزة',
            }}
            locale={locale}
            currentCategoryUrl={currentCategory?.innova_url}
          />
        )}
      </div>
    </>
  );
}

export default Header;
